module.exports = __webpack_public_path__ + "assets/img/auto.ccaaa3e8.png";